export default __webpack_public_path__ + "static/media/hotel1.a972d8a7.jpg";